import { LegalPageLayout } from "../components/LegalPageLayout.tsx";
import { privacyDoc } from "../legalDocs.ts";
import legalTranslations from "../legalTranslations.json";

export const Privacy = ({
  initialLang = "en",
}: {
  initialLang?: "en" | "he";
}) => (
  <LegalPageLayout
    docEn={privacyDoc}
    docHe={legalTranslations.privacy}
    initialLang={initialLang}
  />
);
